import { Dispatch, FC, SetStateAction } from 'react';

import { DimensionValue, VISUALISATION_OPIONS } from './constants';
import { DialogTitle } from '@radix-ui/react-dialog';

import { Button, DialogClose } from '@/components/atoms';
import {
  FilterDropdown,
  FilterDropdownOption,
} from '@/components/organisms/Dropdowns/FilterDropdown/FilterDropdown';

export type FieldSelections = Record<string, FilterDropdownOption | null>;
export type SetFieldSelections = Dispatch<SetStateAction<FieldSelections>>;

type EditCellSidebarProps = {
  title: string;
  selectedDimension: DimensionValue;
  fieldSelections: FieldSelections;
  setFieldSelections: SetFieldSelections;
  onCancelClick: () => void;
  onSaveClick: (fieldSelections: FieldSelections) => void;
  setSelectedDimension: Dispatch<SetStateAction<DimensionValue>>;
};

export const EditCellSidebar: FC<EditCellSidebarProps> = ({
  title,
  selectedDimension,
  fieldSelections,
  setFieldSelections,
  onCancelClick,
  onSaveClick,
  setSelectedDimension,
}) => {
  const visualisaionConfig = VISUALISATION_OPIONS.find(
    ({ value }) => value === selectedDimension.value
  );

  const handleChangeDimension = (option: FilterDropdownOption | null) => {
    setSelectedDimension(option as DimensionValue);
  };

  const handleFieldChange = (key: string) => (option: FilterDropdownOption | null) => {
    setFieldSelections(prev => ({
      ...prev,
      [key]: option,
    }));
  };

  return (
    <div className="flex flex-col gap-5 h-full">
      <DialogTitle className="text-body-20-semibold text-custom-warm-grey-800">{title}</DialogTitle>

      <div className="flex-grow">
        <div className="flex flex-col gap-5">
          <FilterDropdown
            label="Visualisation"
            placeholder="Select visualisation"
            options={VISUALISATION_OPIONS}
            value={selectedDimension}
            onChange={handleChangeDimension}
            className="w-full"
          />
          {visualisaionConfig?.options?.map(
            ({ value, label, placeholder, options, clearable, optional }) => (
              <FilterDropdown
                clearable={clearable}
                optional={optional}
                key={value}
                label={label}
                placeholder={placeholder}
                options={options}
                value={fieldSelections[value] || null}
                onChange={handleFieldChange(value.toString())}
                className="w-full"
              />
            )
          )}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <DialogClose asChild>
          <Button size="lg" variant="secondary" className="w-full" onClick={onCancelClick}>
            Cancel
          </Button>
        </DialogClose>

        <DialogClose asChild>
          <Button
            size="lg"
            variant="primary"
            className="w-full"
            onClick={() => onSaveClick(fieldSelections)}
          >
            Save changes
          </Button>
        </DialogClose>
      </div>
    </div>
  );
};
